import { KenticoFormControlHelpers } from './helpers/KenticoFormControlHelpers';
import { KenticoRulesCreator } from './builders/KenticoRulesCreator';
import { FormStepHelpers } from './helpers/KenticoFormStepHelpers';
import { createControl } from './control/create-control';
import { kenticoFormControlToReactFormControlMap } from './builders/kentico-formcontrol-to-react-formcontrol-map';
import { PageTypeService } from '../services/PageTypeService';
import { getResourceString } from './resource-strings';
import { IField, IFormFieldDefinition } from '../interfaces/Fields';

function isOfType(field: IField, types: string[]) {
    return types.indexOf(field.settings.controlname) >= 0;
}

export function convertKenticoRawFormToJSONFormAsData(data: any, formConfig: any, formName : string) {

    if(!data || !data.form || !data.form.field){
        // tslint:disable-next-line
        console.log('Unable to convertKenticoRawFormToJSONFormAsData');        
        return;
    }
    let formStep: string = formName;
    let categoryIndex: number = 0;
    let categoryName : string = "default";
    let formFieldOverrides = formConfig.formOverrides || {};
    let formDefinitions = {};
    formDefinitions[formName] = [];

    if (formConfig.startForm == "form") {
        formConfig.startForm = formName;

        if (formConfig.formSteps && formConfig.formSteps.length == 0) {
            formConfig.formSteps = [formName];
        }
    } 
    
    if (formConfig.pageSettings && formConfig.pageSettings.form) {
        formConfig.pageSettings[formName] = formConfig.pageSettings.form;
    }
    
    if (!formConfig.pageSettings) {
        formConfig.pageSettings = {};
    }

    formConfig.formSteps = (formConfig.formSteps || []).map((stepName) => {
        if (stepName === "form") {
            return formName;
        }
        return stepName;
    });
    
    if (!formConfig.formStepCaptions || formConfig.formStepCaptions.length == 0) {
        formConfig.formStepCaptions = [];
    }

    if (formConfig.autoInsertFormFieldGroup) {
        let hasFieldGroup = false;
        data.form.field.map((field: any, index: number) => {
            if (isOfType(field, ['category', 'FormFieldGroup'])) {
                hasFieldGroup = true;           
            }
        });

        if (!hasFieldGroup) {
            data.form.field.unshift({            
                "@allowempty": "true",
                "@column": "FormFieldGroupTitle",
                "@columnsize": "1",
                "@columntype": "text",
                "@guid": "ae6d012f-45e6-4a68-94ac-0856a42c5c2b",
                "@visible": "true",
                "properties": {
                    "fieldcaption": " "
                },
                "settings": {
                    "controlname": "FormFieldGroup",
                    "GroupStyling": "standard"
                }
                
            });
        }
    }
    
    let isVoornaamFieldFound: boolean = false;
    let isVoorlettersFieldFound : boolean = false;
    // Parse the form fields in the given Kentico Form dataset
    data.form.field.forEach((field: IField, index: number) => {
        // Only those fields visible to the user
        if (
            field['@system'] !== undefined ||
            field['@system'] ||
            field['@publicfield'] === 'false' ||
            (field.settings && field.settings.FormConfig ||
            isOfType(field, ['QuizUitkomst'])  ||
            isOfType(field, ['FileUploadSettings']))
        ) {
            // No action
        } else {
            // Increase index in case of Category / Field Group
            if (isOfType(field, ['category', 'FormFieldGroup'])) {
                categoryIndex++;
                categoryName = field['@column'];                
            }

            // FILL / HANDLE FORM STEPS
            if (isOfType(field, ['FormStep'])) {
                // Form step
                formStep = FormStepHelpers.addFormStep(
                    field,
                    index,
                    data,
                    formStep,
                    formDefinitions,
                    formConfig
                );

                isVoornaamFieldFound = false;
                isVoorlettersFieldFound = false;
                
            } else if (isOfType(field, ['ContributieTabel'])) { 
                formDefinitions[formStep].push(
                    ...KenticoFormControlHelpers.getContributieTabel(
                        field,
                        categoryName,
                        formFieldOverrides
                    )
                );
                            
            } else if (isOfType(field, ['Adresblok'])) {
                // Adresblok
                // Add controls

                let readOnly = false;

                if (field.properties && field.properties.enabledmacro) {
                    readOnly = field.properties.enabledmacro["#text"] == "{%false%}";
                }

                let prefixVoorAdresblokVelden = "";

                if (field.settings && field.settings.PrefixVoorAdresblokVelden) {
                    prefixVoorAdresblokVelden = field.settings.PrefixVoorAdresblokVelden;
                }
                formConfig.urlMappings = {...formConfig.urlMappings || {},
                    [prefixVoorAdresblokVelden + "countries"] : "/api/esb/getcountries"
                };

                formConfig.urlMappingsRelatedData = {...formConfig.urlMappingsRelatedData || {},
                    [prefixVoorAdresblokVelden + "postcode"] : "/api/esb/getaddress"
                };

                formConfig.parameterMappings = {...formConfig.parameterMappings || {}};
                formConfig.parameterMappings[prefixVoorAdresblokVelden + "postcode"] = [{
                            "field": prefixVoorAdresblokVelden + "Postcode",
                            "mapsTo": "postcode"
                        },
                        {
                            "field": prefixVoorAdresblokVelden + "Huisnummer",
                            "mapsTo": "huisnummer"
                        }
                ];

                formConfig.outputMappings = {...formConfig.outputMappings || {}};
                formConfig.outputMappings[prefixVoorAdresblokVelden + "postcode"] = [{
                        "field": "streetField",
                        "mapsTo": prefixVoorAdresblokVelden + "Straat"
                    },
                    {
                        "field": "cityField",
                        "mapsTo": prefixVoorAdresblokVelden + "Woonplaats"
                    }
                ];          
                
                const pageType = PageTypeService.getPageType();

                if (pageType === "edit" || pageType === "dashboard" && !readOnly) {
                    formDefinitions[formStep].push(
                        ...KenticoFormControlHelpers.getAddressControls(
                            field,
                            categoryName + prefixVoorAdresblokVelden,
                            formFieldOverrides
                        )
                    );
                    
                    categoryName = categoryName + prefixVoorAdresblokVelden + "-na-adresblok";

                } else {
                    formDefinitions[formStep].push(
                        ...KenticoFormControlHelpers.getAddressControlsReadOnly(
                            field,
                            categoryName,
                            formFieldOverrides
                        )
                    );
                }
            } else 
            {
                // Simple fields and popups / custom controls
                // Create a control
                let control: IFormFieldDefinition = createControl(field, categoryName);

                if (isOfType(field, ['FormFieldGroup'])) {
                    if ((index + 1) < data.form.field.length) {
                        const nextField = data.form.field[index + 1];
                        if (isOfType(nextField, ['Adresblok'])) {
                            control.isAdresBlokField = true;
                        }
                    }
                }
                // Build control by getting all builders of specific type and executing them
                kenticoFormControlToReactFormControlMap.forEach(mapping => {
                    if (isOfType(field, mapping.type)) {
                        control = mapping.builder(field, control, formFieldOverrides);
                    }
                });
                // Add to form step
                if (control !== undefined) {

                    if (control.name === 'Voornaam') {
                        isVoornaamFieldFound = true;
                        if (!isVoorlettersFieldFound) {
                            control.cssClass = (control.cssClass || '') + ' voornaam-first-fieldorder';
                        } else {
                            control.cssClass = (control.cssClass || '') + ' voorletter-first-fieldorder';
                        }
                    }
                    if (control.name == 'Voorletters') {
                        isVoorlettersFieldFound = true;
                    }

                    formDefinitions[formStep].push(control);
                }
            }
        }
    });

    for (let formStep in formDefinitions) {
        if (formDefinitions.hasOwnProperty(formStep) && formDefinitions[formStep]) {
            formDefinitions[formStep].map((control : any, index : number) => {
                if (control.name == "Voornaam") {

                    if (index + 1 < formDefinitions[formStep].length) {
                        if (formDefinitions[formStep][index + 1].name == "Achternaam") {
                            if (index == 0 || (index > 0 && formDefinitions[formStep][index - 1].name !== "Voorletters")) {
                                control.cssClass = (control.cssClass || "") + " voornaam-achternaam--geen-voorletters";
                            }
                        }
                    }
                }
            });
        }
    }
    
    if (formConfig.formSteps.length > 0) {
        formConfig.startForm = formConfig.formSteps[0];
    }

    // Handle additional controls from configuration
    if (formConfig.additionalFormControls !== undefined) {
        formDefinitions[formStep].push(
            ...formConfig.additionalFormControls.map(formControl => {
                return (<any> Object).assign({}, formControl, {
                    section: 'category-' + categoryName
                });
            })
        );
    }

    formConfig.formSteps.forEach((formStep) => {
        let buttonCaption = getResourceString("Form.Step.Next");

        if (formConfig.buttons && formConfig.buttons[formStep]) {
            buttonCaption = formConfig.buttons[formStep];
        }
        
        if (formConfig.formSteps.length == 1) {
            if (!!formConfig.noAutoGenerateSummary) {
                buttonCaption = formConfig.submitButtonCaption || getResourceString("Form.Submit.Button") || 'Aanpassen';
            }
        }
        let formStepName = formStep;

        formDefinitions[formStepName].push(
            KenticoRulesCreator.mergeFormDefinition(
                {
                    name: 'submit',
                    label: buttonCaption,
                    type: 'submit'
                },
                formFieldOverrides
            )
        );
    });    

    return formDefinitions;
}
